import apiClient from './axiosClient';

const getPlaceDetailsByPlaceIdRequest = async (place_id: string) => {
  return apiClient.get(`places/details/${place_id}`).then((res) => res.data);
};

export default getPlaceDetailsByPlaceIdRequest;
